import { render, staticRenderFns } from "./LinkedinIcon.vue?vue&type=template&id=13643953&scoped=true"
import script from "./LinkedinIcon.vue?vue&type=script&lang=ts"
export * from "./LinkedinIcon.vue?vue&type=script&lang=ts"
import style0 from "./LinkedinIcon.vue?vue&type=style&index=0&id=13643953&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13643953",
  null
  
)

export default component.exports